import { useTaxiparkQueryParams } from '~/shared/lib/useTaxiparkQueryParams'
import { Button } from '~/shared/ui/Buttons'
import {
  Description,
  Wrapper,
  TitleWrapper,
  Title,
  Img,
  ButtonWrapper,
} from './styled'

export function ErrorStep() {
  const { xTaxiparkKeyQuery } = useTaxiparkQueryParams()

  return (
    <Wrapper>
      <TitleWrapper>
        <Title>Попробуйте снова</Title>
        <Description>к сожалению, произошла ошибка</Description>
      </TitleWrapper>

      <Img src='/images/Error.png' alt='' />

      <ButtonWrapper>
        <Button
          fullWidth
          variant='limeFlooded'
          size='large'
          to='/login'
          style={{ marginBottom: '12px' }}
        >
          Попробовать еще раз
        </Button>

        <Button
          fullWidth
          variant='lightSteelBlueBorder'
          size='large'
          to={`/booking-cars?xTaxiparkKey=${xTaxiparkKeyQuery}`}
        >
          Вернуться к каталогу
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}
